import { z, TypeOf } from 'zod';

export const customerSession = z.object({
    id: z.string(),
    createdAt: z.coerce.date(),
    utmSource: z.string(),
    utmMedium: z.string(),
    utmCampaign: z.string(),
    utmContent: z.string(),
    url: z.string(),
    referrer: z.string(),
    userAgent: z.string(),
    deviceType: z.enum([
        'mobile',
        'desktop',
        'tablet',
        'wearable',
        'console',
        'smarttv',
        'embedded'
    ]),
    deviceVendor: z.string(),
    deviceModel: z.string(),
    browserName: z.string(),
    browserVersion: z.string(),
    osName: z.string(),
    osVersion: z.string()
});

export type CustomerSession = TypeOf<typeof customerSession>;
